module.exports = __webpack_public_path__ + "/images/shop/icon/catalog/windscreen_window_cleaning_system.svg";